import InvestUnitSmall from '@/src/components/AppComponents/InvestUnit/InvestUnitSmall/InvestUnitSmall';
import { Button } from '@/src/components/Commons/Button';
import SearchString from '@/src/components/Commons/Controllers/SearchString';
import { IFundListForUsers } from '@/src/hooks/useFundListForHome';
import useWindowSize from '@/src/hooks/useResponsive';
import { FundWithDetailsEntity, PriceHistoricApi, startOfDay } from '@/src/lib/MayzSmartDB';
import { Token_Historic_Price } from '@/src/lib/SmartDB';
import { ActionType, useAppStore, useHomeStore, useTokensStore } from '@/src/store';
import { FundDataPrice } from '@/src/types/charts';
import { hexToStr } from '@/src/lib/MayzSmartDB';
import { CHEVRON_DOWN, EYE_HIDE, EYE_SHOW } from '@/src/lib/SmartDB/Commons/Constants/images';
import { useEffect, useRef, useState } from 'react';
import { IFundDetailsForUsers } from '../../../../../../hooks/useFundDetailsForHome';
import FundDetailsLoader from '../FundDetailsLoader/FundDetailsLoader';
import ChartContainer from './ChartContainer/ChartContainer';
import FundData from './FundData/FundData';
import styles from './FundDetails.module.scss';
import TokenDetails from './TokenDetails/TokenDetails';
import { isWebsiteDApp } from '@/src/utils/constants';
import { ROUTES } from '@/src/utils/routes';
import { useRouter } from '@/src/store/router/RouterProvider';

type FundDetailsProps = {};

export default function FundDetails(props: FundDetailsProps & IFundDetailsForUsers & IFundListForUsers) {
    //--------------------------------------
    const { id, isLoadingList, searchString, setSearchString, list, fund, isLoadingDetails, isLoadedDetails, protocol, refreshDetails, totalItems } = props;
    //--------------------------------------
    const { currentId, setCurrentId, currentAction, setCurrentAction, currentMode, setCurrentMode } = useHomeStore();
    //--------------------------------------
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [dropdownWidth, setDropdownWidth] = useState<number | null>(null);
    const dropdownRef = useRef<HTMLDivElement>(null);
    //--------------------------------------
    const { width } = useWindowSize();
    const isMobile = width < 480;
    const isTablet = width < 900;
    const isDesktop = width > 1100;
    //--------------------------------------
    const [data, setData] = useState<FundDataPrice[]>([]);
    //--------------------------------------
    const appStore = useAppStore();
    const tokensStore = useTokensStore();
    //--------------------------------------
    const router = useRouter();
    //--------------------------------------
    const [isHide, setIsHide] = useState<boolean>(true);
    const toogleChart = () => {
        isHide ? setIsHide(false) : setIsHide(true);
    };
    //--------------------------------------
    const [isLoadedHistoric, setIsLoadedHistoric] = useState<boolean>(false);
    const isAddedCurrentRef = useRef(false);
    //--------------------------------------
    const loadPricesHistory = async () => {
        if (fund !== undefined) {
            const historic_prices: Token_Historic_Price[] = await PriceHistoricApi.get_Token_Historic_PriceADAx1e6x1e3_Api(fund.getNET_id_CS(), fund.fdFundFT_TN_Hex, 90);
            
            // console.log(`[FundDetails] - loadPricesHistory - ADA USD: `)
            // console.table(tokensStore.adaUsdPriceHistoric)
            // console.log(`[FundDetails] - loadPricesHistory - historic_prices: `)
            // console.table(historic_prices)

            const data: FundDataPrice[] = historic_prices.map((item, index) => {
                const priceADAx1e6 = Number(item.priceADAx1e6 ?? 0n);
                
                // Find the ADA/USD price for this specific date
                const adaUsdPriceForDate = tokensStore.adaUsdPriceHistoric.find(
                    (adaPrice) => adaPrice.timestamp === item.date   
                )?.price;

                // Calculate USD price if we have the ADA/USD rate for that day
                const priceUSDx1e6 = adaUsdPriceForDate !== undefined 
                    ? priceADAx1e6 * adaUsdPriceForDate 
                    : undefined;
                
                return {
                    date: index === historic_prices.length - 1 ? startOfDay(new Date(Number(item.date))) : new Date(Number(item.date)),
                    priceADAx1e6,
                    priceUSDx1e6,
                    adaUsdPriceForDate
                };
            });

            // LOG IN CONSOLE AS TABLE PRICE ADA, USD AND RATE
            // console.table(data);

            setData(data);
            setIsLoadedHistoric(true);
        }
    };
    //--------------------------------------
    const renderFundsList = () => (
        <div className={styles.dropdown} style={{ width: dropdownWidth ?? '450px' }}>
            <div className={styles.dropdownSearch}>
                <SearchString isLoadingList={isLoadingList} searchString={searchString} setSearchString={setSearchString} />
            </div>
            {isLoadingList ? (
                <p className={`${styles.textLoading}`}>
                    <p className={`${styles.rowSkeleton}`}></p>
                </p>
            ) : list.length === 0 ? (
                <p className={styles.textNoFunds}>No funds found</p>
            ) : (
                <ul className={styles.dropdownList}>
                    {list?.map((fund) => (
                        <li key={fund._DB_id} className={`${styles.dropdownListItem} ${id === fund._DB_id && styles.active}`} onClick={() => handleSelectFund(fund)}>
                            <p>{fund.name}</p>
                            <h2>[{hexToStr(fund.fdFundFT_TN_Hex)}]</h2>
                            <InvestUnitSmall investUnitWithDetails={fund.investUnit} />
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
    //--------------------------------------
    const openDropdown = () => {
        console.log('toggleDropdown' + isDropdownOpen);
        setIsDropdownOpen(isDropdownOpen ? false : true);
    };
    //--------------------------------------
    useEffect(() => {
        const updateWidth = () => {
            if (dropdownRef.current) {
                setDropdownWidth(dropdownRef.current.offsetWidth);
            }
        };

        // Run when component mounts & when dropdown opens
        updateWidth();

        // Listen for window resize to adjust width dynamically
        window.addEventListener('resize', updateWidth);
        return () => window.removeEventListener('resize', updateWidth);
    }, [isDropdownOpen]);
    //--------------------------------------
    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsDropdownOpen(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [dropdownRef]);
    //--------------------------------------
    useEffect(() => {
        setIsHide(true);
    }, [isDesktop]);
    //--------------------------------------
    useEffect(() => {
        if (isLoadedDetails === true && fund !== undefined) {
            // Reset state when fund changes
            setData([]);
            setIsLoadedHistoric(false);
            isAddedCurrentRef.current = false;
            loadPricesHistory();
        }
    }, [fund, isLoadedDetails]);
    //--------------------------------------
    useEffect(() => {
        if (isLoadedHistoric === true && fund !== undefined && tokensStore.isAddingTokens === false && isAddedCurrentRef.current === false) {
            const currentTokenFT = tokensStore.getTokenPriceAndMetadata(fund.getNET_id_CS(), fund.fdFundFT_TN_Hex);
            if (currentTokenFT !== undefined && currentTokenFT.date !== undefined && currentTokenFT.priceADAx1e6 !== undefined) {
                isAddedCurrentRef.current = true;
                const currentPriceADAx1e6 = Number(currentTokenFT.priceADAx1e6.toString());
                const currentAdaUsdPrice = tokensStore.adaUsdPrice;
                const currentPriceUSDx1e6 = currentAdaUsdPrice !== undefined 
                    ? currentPriceADAx1e6 * currentAdaUsdPrice 
                    : undefined;
                
                setData(prev => [
                    ...prev,
                    {
                      date: new Date(Number(currentTokenFT!.date!.toString())),
                      priceADAx1e6: currentPriceADAx1e6,
                      priceUSDx1e6: currentPriceUSDx1e6,
                      adaUsdPriceForDate: currentAdaUsdPrice
                    }
                ]);
            }
        }
    }, [isLoadedHistoric, tokensStore.isAddingTokens]);
    //--------------------------------------
    const handleClickOpenInNewTab = (url: string | undefined) => {
        if (url === undefined) return;
        window.open(url, '_blank');
    };
    //--------------------------------------
    async function handleSelectFund(selected: FundWithDetailsEntity) {
        setIsDropdownOpen(false);
        router.replace(`${ROUTES.HOME}?action=${currentAction}&mode=${currentMode}&id=${selected._DB_id}`, undefined, { shallow: true }).then((success) => {
            //          setCurrentId(selected._DB_id);
            // setCurrentMode('Details');
        });
    }
    //--------------------------------------
    const handleBtnList = async () => {
        router.replace(`${ROUTES.HOME}?action=${currentAction}&mode=List&id=${currentId}`, undefined, { shallow: true }).then((success) => {
            // setCurrentMode('List');
        });
    };
    //--------------------------------------
    const handleClickBtnAction = (type: ActionType, fund: FundWithDetailsEntity) => {
        // router.replace(`${ROUTES.HOME}?action=${type}`).then((success) => {
        //     setCurrentId(fund._DB_id);
        //     setCurrentAction(type);
        // });
        router.replace(`${ROUTES.HOME}?action=${type}&mode=${currentMode}&id=${fund._DB_id}`, undefined, { shallow: true }).then((success) => {
            // setCurrentId(fund._DB_id);
            // setCurrentAction(type);
        });
    };
    //--------------------------------------
    return (
        <>
            {props.isLoadingDetails === true && (fund === undefined || (fund !== undefined && fund._DB_id !== id)) ? (
                <>
                    <FundDetailsLoader />
                </>
            ) : null}
            <main className={styles.fundsDetailsSection}>
                {props.isLoadedDetails === true && fund === undefined ? <p>Not Found</p> : null}
                {fund && fund._DB_id === id ? (
                    <>
                        <section className={styles.fundSection}>
                            <div className={styles.fundHeader}>
                                <div className={styles.fundName} ref={dropdownRef}>
                                    <InvestUnitSmall investUnitWithDetails={fund.investUnit} />
                                    <div
                                        className={`${styles.selectFund} ${totalItems !== undefined && totalItems > 1 ? styles.cursorPointer : ''}`}
                                        onClick={() => {
                                            totalItems !== undefined && totalItems > 1 && openDropdown();
                                        }}
                                    >
                                        <p className={styles.name}>
                                            {fund.name} [{hexToStr(fund.fdFundFT_TN_Hex)}]
                                        </p>
                                        {totalItems !== undefined && totalItems > 1 && (
                                            <svg width="16" height="16" className={`${styles.icon} ${isDropdownOpen ? styles.open : ''}`}>
                                                <use href={CHEVRON_DOWN}></use>
                                            </svg>
                                        )}
                                    </div>
                                    {isDropdownOpen && renderFundsList()}
                                </div>
                                <div className={styles.fundActions}>
                                    <Button
                                        mode="outline"
                                        size="small"
                                        active={currentAction === 'Swap' && fund._DB_id === currentId}
                                        arrow={false}
                                        onClick={() => handleClickBtnAction('Swap', fund)}
                                    >
                                        BUY/SELL
                                    </Button>
                                    <Button
                                        mode="outline"
                                        size="small"
                                        active={currentAction === 'Deposit' && fund._DB_id === currentId}
                                        arrow={false}
                                        onClick={() => handleClickBtnAction('Deposit', fund)}
                                    >
                                        MINT/REDEEM
                                    </Button>
                                    {isWebsiteDApp && (
                                        <Button
                                            mode="outline"
                                            size="small"
                                            active={currentAction === 'Delegate' && fund._DB_id === currentId}
                                            arrow={false}
                                            onClick={() => handleClickBtnAction('Delegate', fund)}
                                        >
                                            STAKE/UNSTAKE
                                        </Button>
                                    )}
                                    {totalItems !== undefined && totalItems > 1 && (
                                        <Button mode={'link'} width={90} size="small" arrow={false} onClick={() => handleBtnList()}>
                                            MORE FUNDS
                                        </Button>
                                    )}
                                </div>
                            </div>
                            <FundData fund={fund} isTablet={isTablet} />
                            {!isDesktop && (
                                <div className={styles.toogleChart} onClick={toogleChart}>
                                    {isHide ? (
                                        <div className={styles.toogle}>
                                            <svg width="24" height="24" className={styles.icon}>
                                                <use href={EYE_HIDE}></use>
                                            </svg>
                                            <p className={styles.text}>Show chart</p>
                                        </div>
                                    ) : (
                                        <div className={styles.toogle}>
                                            <svg width="24" height="24" className={styles.icon}>
                                                <use href={EYE_SHOW}></use>
                                            </svg>
                                            <p className={styles.text}>Hide chart</p>
                                        </div>
                                    )}
                                </div>
                            )}
                            <ChartContainer isDesktop={isDesktop} fund={fund} isHide={isHide} data={data} isLoading={!isLoadedHistoric} />
                            <div className={styles.footerFundDetail}>
                                <TokenDetails fund={fund} isTablet={isTablet} />
                                <div className={styles.btnGroup}>
                                    <Button
                                        mode="link-arrow"
                                        size="very-small"
                                        onClick={() =>
                                            handleClickOpenInNewTab(
                                                appStore.siteSettings !== undefined ? `${appStore.siteSettings.getblockfrost_url_explorer_policy(fund.getNET_id_CS())}` : ``
                                            )
                                        }
                                    >
                                        TOKEN POLICY
                                    </Button>
                                    <Button
                                        mode="link-arrow"
                                        size="very-small"
                                        onClick={() =>
                                            handleClickOpenInNewTab(
                                                appStore.siteSettings !== undefined ? `${appStore.siteSettings.getblockfrost_url_explorer_address(fund.getNet_Address())}` : ``
                                            )
                                        }
                                    >
                                        SMART CONTRACT
                                    </Button>
                                </div>
                            </div>
                        </section>
                    </>
                ) : null}
            </main>
        </>
    );
    //--------------------------------------
}
